import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7c3 -2 6 -2 9 0s6 2 9 0","key":"svg-0"}],["path",{"d":"M3 17c3 -2 6 -2 9 0s6 2 9 0","key":"svg-1"}],["path",{"d":"M3 12c3 -2 6 -2 9 0s6 2 9 0","key":"svg-2"}]]

const IconRipple = createReactComponent('outline', 'ripple', 'Ripple', __iconNode);

export default IconRipple;